import { motion } from "framer-motion";
import { ArrowUpRight, Trophy, Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SPEEDWEEK } from "@/data/site";

export const SpeedWeekSection = () => {
  return (
    <section data-testid="speedweek-section" className="relative overflow-hidden py-24 md:py-36">
      {/* Full-bleed background */}
      <img src={SPEEDWEEK.image} alt="Bahamas Speed Week Revival" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#050505]/85" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-[#050505]/70" />
      <div className="grain-overlay" />

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-3 flex items-center gap-3">
          <span className="h-[2px] w-10 bg-kbyellow" />
          <span className="font-display text-base tracking-[0.3em] text-kbcyan">OUR HERITAGE</span>
        </div>
        <h2 className="max-w-3xl font-display text-6xl leading-[0.85] tracking-tight text-white md:text-8xl">
          The Bahamas <span className="text-kbyellow">Speed Week</span> Revivals
        </h2>

        <div className="mt-12 grid gap-12 md:grid-cols-2">
          <div className="space-y-5">
            {SPEEDWEEK.body.map((p, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className="text-lg leading-relaxed text-white/75">{p}</p>
              </Reveal>
            ))}

            <Reveal delay={0.1}>
              <div className="mt-4 flex flex-wrap gap-4">
                {SPEEDWEEK.sources.map((s) => (
                  <a
                    key={s.href}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`speedweek-source-${s.href.replace(/[^a-z0-9]+/gi, "-").slice(8, 28)}`}
                    className="inline-flex items-center gap-1.5 rounded-lg border border-white/15 bg-white/5 px-3 py-1.5 text-xs text-white/60 transition-colors hover:border-kbcyan hover:text-kbcyan"
                  >
                    {s.label}
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                ))}
              </div>
            </Reveal>
          </div>

          {/* David McLaughlin card */}
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-xl border border-white/10 bg-black/50 backdrop-blur-md">
              <div className="relative flex items-center justify-center overflow-hidden bg-black/60">
                <img src={SPEEDWEEK.davidImg} alt="David McLaughlin" className="mx-auto max-h-[560px] w-auto object-contain" />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/85 to-transparent" />
                <span className="absolute bottom-4 left-5 font-display text-3xl tracking-wide text-white">David McLaughlin</span>
              </div>
              <div className="p-7">
                <div className="flex gap-3">
                  <Star className="mt-1 h-6 w-6 flex-shrink-0 text-kbyellow" />
                  <p className="leading-relaxed text-white/70">{SPEEDWEEK.david}</p>
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  {["President, EduKarting Bahamas", "President, Bahamas Motor Sports Federation", "Head Organiser, Speed Week Revivals"].map((t) => (
                    <span key={t} className="inline-flex items-center gap-1.5 rounded-full bg-kbcyan/10 px-3 py-1.5 text-xs font-medium text-kbcyan">
                      <Trophy className="h-3.5 w-3.5" />
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default SpeedWeekSection;
